(() => {
  const STORAGE_KEY = 'ci:collection-view';

  const initCuratedCollection = (scope = document) => {
    const sections = scope.querySelectorAll('[data-ci-collection-curated]');
    sections.forEach((section) => {
      if (section.dataset.ciCuratedReady) return;
      section.dataset.ciCuratedReady = 'true';

      const regularView = section.querySelector('.ci-collection-view-regular');
      const curatedView = section.querySelector('.ci-collection-view-curated');
      const overlay = section.parentElement?.querySelector('[data-ci-curated-overlay]')
        || document.querySelector('[data-ci-curated-overlay]');
      const filterDrawer = section.querySelector('[data-ci-curated-filter-drawer]');
      const sortSelect = section.querySelector('#SortBy, .ci-collection-sort-by');

      const setViewMode = (mode) => {
        const viewBtns = section.querySelectorAll('[data-ci-collection-view]');
        const isCurated = mode === 'curated';

        if (regularView) {
          if (isCurated) {
            regularView.setAttribute('hidden', '');
          } else {
            regularView.removeAttribute('hidden');
          }
        }

        if (curatedView) {
          if (isCurated) {
            curatedView.removeAttribute('hidden');
          } else {
            curatedView.setAttribute('hidden', '');
          }
        }

        viewBtns.forEach((btn) => {
          btn.classList.toggle('is-active', btn.getAttribute('data-ci-collection-view') === mode);
        });

        try {
          localStorage.setItem(STORAGE_KEY, mode);
        } catch (e) {
          /* ignore */
        }

        if (typeof window.initProductCardVideos === 'function') {
          window.initProductCardVideos(section);
        }
      };

      section.querySelectorAll('[data-ci-collection-view]').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          setViewMode(btn.getAttribute('data-ci-collection-view'));
        });
      });

      let savedView = null;
      try {
        savedView = localStorage.getItem(STORAGE_KEY);
      } catch (e) {
        /* ignore */
      }
      setViewMode(savedView === 'grid' ? 'grid' : 'curated');

      const updateStickyToolbarOffset = () => {
        const headerSection =
          document.querySelector('.shopify-section--header') ||
          document.getElementById('shopify-section-header');
        const headerHeight = headerSection ? headerSection.offsetHeight : 0;

        document.documentElement.style.setProperty('--site-header-height', `${headerHeight}px`);
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      };

      updateStickyToolbarOffset();
      window.addEventListener('resize', updateStickyToolbarOffset);
      window.addEventListener('scroll', updateStickyToolbarOffset, { passive: true });
      document.addEventListener('shopify:section:load', updateStickyToolbarOffset);

      const openFilterDrawer = () => {
        if (filterDrawer) filterDrawer.classList.add('is-open');
        if (overlay) overlay.classList.add('is-visible');
        document.body.classList.add('ci-collection-curated-scroll-lock');
      };

      const closeFilterDrawer = () => {
        if (filterDrawer) filterDrawer.classList.remove('is-open');
        if (overlay) overlay.classList.remove('is-visible');
        document.body.classList.remove('ci-collection-curated-scroll-lock');
      };

      section.querySelectorAll('[data-ci-curated-filter-toggle]').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          openFilterDrawer();
        });
      });

      section.querySelectorAll('[data-ci-curated-filter-close]').forEach((btn) => {
        btn.addEventListener('click', (event) => {
          event.preventDefault();
          closeFilterDrawer();
        });
      });

      if (overlay) {
        overlay.addEventListener('click', closeFilterDrawer);
      }

      if (sortSelect) {
        sortSelect.addEventListener('change', function onSortChange() {
          const params = new URLSearchParams(window.location.search);
          params.set(this.name, this.value);
          window.location = `?${params.toString()}`;
        });
      }

      const form = section.querySelector('.filter-form');
      if (form) {
        if (!form.getAttribute('method')) form.setAttribute('method', 'get');
        if (!form.getAttribute('action')) {
          form.setAttribute('action', window.location.pathname);
        }

        form.querySelectorAll('.filter-group-display__list input').forEach((input) => {
          input.addEventListener('change', () => form.submit());
        });

        section.querySelectorAll('.filter-group-display').forEach((display) => {
          const group = display.closest('.filter-group');
          if (group && group.hasAttribute('open')) {
            display.style.display = '';
          } else {
            display.style.display = 'none';
          }
        });

        section.querySelectorAll('.filter-group-summary').forEach((summary) => {
          summary.addEventListener('click', (event) => {
            event.preventDefault();
            const group = summary.closest('.filter-group');
            if (!group) return;
            const display = group.querySelector('.filter-group-display');
            if (group.hasAttribute('open')) {
              group.removeAttribute('open');
              if (display) display.style.display = 'none';
            } else {
              group.setAttribute('open', '');
              if (display) display.style.display = '';
            }
          });
        });
      }
    });

    if (window.Ajaxinate && document.querySelector('#AjaxinateLoop')) {
      if (!window.__ciCuratedCollectionAjaxinate) {
        window.__ciCuratedCollectionAjaxinate = new window.Ajaxinate({
          method: 'scroll',
          container: '#AjaxinateLoop',
          pagination: '#AjaxinatePagination',
          loadingText: 'Please wait..',
          callback: () => {
            if (typeof window.initProductCardVideos === 'function') {
              window.initProductCardVideos(document.getElementById('AjaxinateLoop') || document);
            }
          },
        });
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => initCuratedCollection());
  document.addEventListener('shopify:section:load', (event) => initCuratedCollection(event.target));
})();
